import * as S from './styles';
import { Title, Logo } from '@getinapp/appetizer';
import { IDS_TO_HIDE_PREDICTION } from '~/utils/constants';

type Props = {
  tablesInLine: number;
  unitName: string;
  unitId: string;
  waitTimeLine: number | null;
  loadingWaitTimeLine: boolean;
  isQrCodeGeneric: boolean | null;
};

export const Header = ({
  tablesInLine,
  unitName,
  unitId,
  waitTimeLine,
  loadingWaitTimeLine,
  isQrCodeGeneric,
}: Props) => {
  return (
    <S.Container data-testid="container">
      <S.LogoWrapper>
        <Logo size="small" />
      </S.LogoWrapper>

      <Title level={2}>Bem-vindo!</Title>
      <S.TitleRestaurant>{unitName}</S.TitleRestaurant>

      <S.WrapperTableCount>
        <S.TableCount>{`${tablesInLine} ${
          isQrCodeGeneric ? 'pessoa(s)' : 'mesa(s)'
        } na fila`}</S.TableCount>
        {!IDS_TO_HIDE_PREDICTION.includes(unitId) &&
          (loadingWaitTimeLine ? (
            <S.Skeleton loading={loadingWaitTimeLine} />
          ) : (
            !!waitTimeLine && (
              <S.WaitTimeText>
                {`Tempo estimado médio em ${Math.round(waitTimeLine)}-${
                  Math.round(waitTimeLine) + 10
                } minutos`}
              </S.WaitTimeText>
            )
          ))}
      </S.WrapperTableCount>
    </S.Container>
  );
};
